import { useDispatch } from 'react-redux';
import { StyledActionItem, StyledActions } from './Actions.style';
import { toggleModal } from 'state/callers';
import Icon from 'components/base/Icon';
import ViewInActivity from './ViewInActivity';
import CopyLink from './CopyLink';

const Actions = () => {
  const dispatch = useDispatch();
  return (
    <StyledActions>
      <StyledActionItem>
        <ViewInActivity />
      </StyledActionItem>
      <StyledActionItem>
        <CopyLink />
      </StyledActionItem>
      <StyledActionItem onClick={() => dispatch(toggleModal())}>
        <Icon name='CloseIcon' size='smaller' color='shuttleGray' />
      </StyledActionItem>
    </StyledActions>
  );
};

export default Actions;
